import React from 'react'
import "../assets/pages-css/home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Copyright from '../components/globals/home/copyright';
import Footer from '../components/globals/home/footer';
import Header from '../components/globals/home/header';

const PrivacyPolicy = () => {

  return (
    <>
      <Header />
      <div className='container mt-4 mb-4'>
        <h1>Privacy Policy</h1>
        <p>At SharkSkillz, we are dedicated to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and disclose personal information when you use our education app, SharkSkillz. By using or accessing SharkSkillz, you acknowledge and accept the practices described in this policy.</p>

        <h2>Collection of Information</h2>
        <h3>1. Personal Information</h3>
        <p>We may collect personal information from users when they register for an account on SharkSkillz. This may include, but is not limited to, your name, email address, age, and avatar preferences.</p>

        <h3>2. Usage Information</h3>
        <p>We automatically collect certain information about how you interact with SharkSkillz, such as the quests you complete, games you play, and the lessons you access. This information is collected through cookies and similar tracking technologies.</p>

        <h3>3. Device Information</h3>
        <p>We may also collect information about the mobile device or computer you use to access SharkSkillz. This may include device identifiers, type of device, operating system, and mobile network information.</p>

        <h2>Use of Information</h2>
        <h3>1. Personalisation and Improve User Experience</h3>
        <p>Your personal information and usage data may be used to personalise your experience on SharkSkillz, provide relevant content, and improve our app's functionality.</p>

        <h3>2. Communication</h3>
        <p>We may use your email address to send you important updates about SharkSkillz, such as new features or changes to our terms and conditions. You can opt-out of receiving these emails at any time by following the unsubscribe instructions provided in the email.</p>

        <h3>3. Research and Analysis</h3>
        <p>We may analyse the aggregated user data to understand trends and patterns, improve our app's effectiveness, and conduct educational research.</p>

        <h3>4. Legal Compliance and Protection</h3>
        <p>In certain circumstances, we may need to use and disclose your personal information to comply with applicable laws, enforce our terms and conditions, prevent fraud or illegal activities, or protect the rights, property, and safety of SharkSkillz, its users, and others.</p>

        <h2>Data Security</h2>
        <p>We take appropriate security measures to protect your personal information from unauthorised access, alteration, disclosure, or destruction. However, please be aware that no method of transmission over the internet or electronic storage is completely secure.</p>

        <h2>Third-Party Services</h2>
        <p>SharkSkillz may use third-party services, such as analytics providers, to help us understand app usage and improve our services. These third-party services may collect and store information according to their own privacy policies. We recommend reviewing the privacy policies of any third-party services used within our app.</p>

        <h2>Children's Privacy</h2>
        <p>SharkSkillz is intended for users of all ages, including children. Parents or guardians are responsible for providing consent and overseeing their child's use of SharkSkillz. We do not knowingly collect personal information from children under the age of 13 without parental consent. If we discover that we have collected personal information from a child without parental consent, we will promptly delete that information.</p>

        <h2>Changes to Privacy Policy</h2>
        <p>We may update or modify this Privacy Policy from time to time. Any changes will become effective upon posting the revised policy within SharkSkillz. By continuing to use SharkSkillz after such changes, you acknowledge and accept the updated Privacy Policy.</p>

        <h2>Contact Us</h2>
        <p>If you have any questions, concerns, or requests related to this Privacy Policy, please contact us at <a href="mailto:skillz@sharkskillz.com">skillz@sharkskillz.com</a>.</p>

        <p>By using SharkSkillz, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.</p>
      </div>
      <Footer />
      <Copyright />
    </>
  )
}

export default PrivacyPolicy;